// PanierSlice.js
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { ArticleType } from "../../../Types/Entites/ArticleType";
import ClientType from "../../../Types/Entites/ClientType";
import axios from "axios";
import { forEach } from "lodash";
import {
  calculateDiscountedPrice,
  calculateRemise,
  LastCreatedRemise,
  maxRemise,
} from "../../../Helpers/helpers";
import {
  GratuiteType,
  ProgramFideliteType,
} from "../../../Types/Entites/RemiseType";
import _ from "lodash";

import { number } from "yup";

import { ToastWarning } from "../../../../Shared/Toasts/ToastWarning";
import { OrderType } from "../../../Types/Entites/Orders/OrderType";

export const findDefaultClientsBySociete = createAsyncThunk(
  "client/findDefaultClientsBySociete",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(
        `client/findDefaultClientsBySociete/${id}`,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);

export const findDefaultClientsBySocieteVerifUserApi = createAsyncThunk(
  "client/findDefaultClientsBySocieteVerifUserApi",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(
        `client/findDefaultClientsBySocieteVerifUserApi/${id}`,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);
interface PanierItem {
  article: ArticleType;
  quantity: number;
  prix_unitaire: number;
  prix_total: number;
  paid_quantity: number;
  sold_quantity: number;
  total_ht?: number;
  total_ht_net?: number;
  typeRemise: string;
  remise: any;
  remiseClient: number;
  prixNet: number;
  free: boolean;
  Solde?: boolean;
  type?: String;
  note?: String;
  remisepropsition?: any;
  defaut_id?: any;
  outOFStock: boolean;
  qtemax?: any;
}

interface PanierState {
  items: PanierItem[];
  refundedItems: PanierItem[];

  timbre: number;
  total: number;
  totalNet: number;
  total_ht: number;
  total_net_ht: number;
  client_id: any;
  defaultClient: any;
  orderConfirmed: boolean;
  calculatedQuantity: number;
  order_id: string | null;
  refundedOrder: any;

  reduction: number;
  operationType: string;
  refundedArticle: any;
  avance?: any;
  Bons: any;
  InstantRemise: number;
  typeRemise: string;
  clientRemise: number;
  programmesFidelite: ProgramFideliteType[];
  gratuites: GratuiteType[];
  selectedOrders: OrderType[];
  refundedOrders: OrderType[];
  reservation: any;
  timbre_facture: Number;
}

const initialState: PanierState = {
  items: [],
  refundedItems: [],
  total: 0,
  total_ht: 0,
  total_net_ht: 0,
  totalNet: 0,
  orderConfirmed: false,
  client_id: "",
  defaultClient: {},
  calculatedQuantity: 1,
  order_id: null,
  refundedOrder: null,
  reduction: 0,
  Bons: [],
  operationType: "Vente",
  refundedArticle: null,
  InstantRemise: 0,
  typeRemise: "pourcentage",
  clientRemise: 0,
  programmesFidelite: [],
  gratuites: [],
  selectedOrders: [],
  refundedOrders: [],
  reservation: null,
  timbre: 0,
  timbre_facture: 0,
};
const addSoldeItem = (
  currentItems: any[],
  soldeArticle: any,
  soldeQte: number,
  remise: number,
) => {
  // Créer une copie superficielle pour ne pas muter l'original prématurément
  let newItems = [...currentItems];

  const existingItemIndex = newItems.findIndex(
    (item: any) =>
      item.Solde === true &&
      String(item.article._id) === String(soldeArticle._id),
  );

  const itemSansSoldeIndex = newItems.findIndex(
    (item: any) =>
      !item.Solde && String(item.article._id) === String(soldeArticle._id),
  );

  if (existingItemIndex !== -1) {
    const existingItem = { ...newItems[existingItemIndex] };

    // Logique de soustraction sur l'article original
    if (existingItem.quantity < soldeQte && itemSansSoldeIndex !== -1) {
      newItems[itemSansSoldeIndex] = {
        ...newItems[itemSansSoldeIndex],
        quantity: newItems[itemSansSoldeIndex].quantity,
      };
    }
    newItems[itemSansSoldeIndex].quantity =
      existingItem.quantity < soldeQte
        ? newItems[itemSansSoldeIndex].quantity - 1
        : newItems[itemSansSoldeIndex].quantity;

    existingItem.quantity = soldeQte;
    existingItem.sold_quantity = soldeQte;
    existingItem.prix_total = soldeQte * existingItem.prix_unitaire;
    existingItem.remise = remise;

    newItems[existingItemIndex] = existingItem;
    console.log("newItems", newItems);
  } else {
    // Si l'article de base existe, on lui retire 1
    if (itemSansSoldeIndex !== -1) {
      newItems[itemSansSoldeIndex] = {
        ...newItems[itemSansSoldeIndex],
        quantity: newItems[itemSansSoldeIndex].quantity - 1,
      };
    }

    // On ajoute le nouveau solde au début (index 0)
    newItems.unshift({
      article: soldeArticle,
      outOFStock: false,
      quantity: soldeQte,
      sold_quantity: soldeQte,
      prix_unitaire: soldeArticle.prix_vente_ttc,
      prix_total: soldeQte * soldeArticle.prix_vente_ttc,
      paid_quantity: 0,
      remise: remise,
      typeRemise: "pourcentage",
      remiseClient: 0,
      prixNet: 0,
      free: false,
      Solde: true,
    });
  }
  return newItems;
};

const PanierSlice = createSlice({
  name: "Panier",
  initialState,
  reducers: {
    addToPanier: (state, action) => {
      const {
        article,
        quantity,
        sold_quantity,
        prix_unitaire,
        defaut,
        prix_total,
        total_ht,
        total_ht_net,
        remise,
        remiseClient,
        prixNet,
        type,
        note,
        remisepropsition,
        defaut_id,
        qtemax,
      } = action.payload;

      const existingItem = state.items.find(
        (item) =>
          item.article._id === article._id &&
          item.free === false &&
          item.type === type &&
          item.remise === remise,
      );

      if (existingItem) {
        const updatedItem = {
          ...existingItem,
          quantity: existingItem.quantity + quantity,
          sold_quantity: existingItem.sold_quantity + quantity,
          prix_total:
            (existingItem.quantity + quantity) *
            existingItem.article.prix_vente_ttc,
          total_ht:
            (existingItem.quantity + quantity) *
            existingItem.article.prix_vente_ht,
        };

        const filteredItems = state.items.filter(
          (item) =>
            !(
              item.article._id === article._id &&
              item.type === type &&
              item.remise === remise
            ),
        );

        const newItems = [updatedItem, ...filteredItems];

        if (updatedItem && type === "defaut" && updatedItem.quantity > qtemax) {
          ToastWarning("la quantite depasse la quantite d'article");
          return;
        }

        return {
          ...state,
          items: newItems,
          totalNet: state.totalNet + article.prix_vente_ttc,
          total: state.total + article.prix_vente_ttc,
          total_ht: state.total_ht + article.prix_vente_ht,
        };
      } else {
        // If the item is not in the cart, add it with quantity 1 and calculate total price
        const newItem: PanierItem = {
          article: article,
          outOFStock: false,
          quantity: quantity,
          sold_quantity: sold_quantity,
          prix_unitaire: prix_unitaire,
          // prix_unitaireHt: prixHt,
          prix_total: prix_total,
          total_ht: total_ht,
          paid_quantity: 0,
          remise: remise,
          typeRemise: "pourcentage",
          remisepropsition: remisepropsition,
          remiseClient: remiseClient,
          prixNet: prixNet,
          total_ht_net: total_ht_net,
          note: note,
          free: false,
          type: type,
          defaut_id: defaut_id,
          qtemax: qtemax,
        };
        return {
          ...state,
          items: [newItem, ...state.items],
          // totalNet: state.totalNet + 10,
          // total: state.totalNet + 10,
        };
      }
    },
    updatePrix: (state, action) => {
      const { article, Newprix } = action.payload;
      // Trouver l'article existant
      const existingItem = state.items.find(
        (item) => item.article._id === article._id,
      );

      if (!existingItem) return state; // Si non trouvé, rien ne change

      // Met à jour la liste des items
      const updatedItems = state.items.map((item) =>
        item.article._id === article._id
          ? {
              ...item,
              article: { ...item.article, prix_vente_ttc: Newprix },
              prix_unitaire: Newprix,
              prix_total: item.quantity * Newprix,
              total_ht: item.quantity * Newprix,
              prixNet: item.quantity * Newprix,
            }
          : item,
      );

      // Recalcul des totaux
      const newTotals = updatedItems.reduce(
        (acc, item) => {
          acc.totalNet += item.prix_total;
          acc.total += item.prix_total;
          acc.total_ht += item?.total_ht || 0;
          return acc;
        },
        { totalNet: 0, total: 0, total_ht: 0 },
      );

      return {
        ...state,
        items: updatedItems,
        ...newTotals,
      };
    },

    addToRefunded: (state, action) => {
      const {
        article,
        quantity,
        sold_quantity,
        prix_unitaire,
        defaut,
        prix_total,
        total_ht,
        total_ht_net,
        remise,
        remiseClient,
        prixNet,
        type,
        note,
        remisepropsition,
        defaut_id,
        qtemax,
      } = action.payload;

      // If the item is not in the cart, add it with quantity 1 and calculate total price
      const newItem: PanierItem = {
        article: article,
        outOFStock: false,
        quantity: quantity,
        sold_quantity: sold_quantity,
        prix_unitaire: prix_unitaire,
        // prix_unitaireHt: prixHt,
        prix_total: prix_total,
        total_ht: total_ht,
        paid_quantity: 0,
        remise: remise,
        typeRemise: "pourcentage",
        remisepropsition: remisepropsition,
        remiseClient: remiseClient,
        prixNet: prixNet,
        total_ht_net: total_ht_net,
        note: note,
        free: false,
        type: type,
        defaut_id: defaut_id,
        qtemax: qtemax,
      };
      return {
        ...state,
        refundedItems: [...state.refundedItems, newItem],
      };
    },
    changetotal: (state, action) => {
      const { total } = action.payload;

      return {
        ...state,
        totalNet: total,
      };
    },
    SelectedOrders: (state, action) => {
      const orders = action.payload.orders;
      const livraison = action.payload.livraison;
      const totalSum = orders?.reduce(
        (sum: any, order: OrderType) => sum + order.totalNet + livraison,
        0,
      );
      return {
        ...state,
        selectedOrders: orders?.map((order: OrderType) => ({
          ...order,
          total: order.societe_livraison?.frais_livraison
            ? order.total + order.societe_livraison?.frais_livraison
            : order.total,
          totalNet: order.societe_livraison?.frais_livraison
            ? order.totalNet + order.societe_livraison?.frais_livraison
            : order.totalNet,
        })),
        total: totalSum | 0,
        totalNet: totalSum | 0,
      };
    },
    selectedRefundedOrders: (state, action) => {
      const dileveryFees = action.payload.frais_livraison;
      const orders = action.payload.orders;
      const totalSum = state.selectedOrders.reduce(
        (sum: any, order: OrderType) => sum + order.totalNet,
        0,
      );

      return {
        ...state,
        refundedOrders: orders,
        total: totalSum - dileveryFees * orders.length,
        totalNet: totalSum - dileveryFees * orders.length,
      };
    },
    setFideliteLIst: (state, action) => {
      return {
        ...state,
        programmesFidelite: action.payload,
      };
    },
    setRemiseType: (state, action) => {
      return {
        ...state,
        typeRemise: action.payload,
      };
    },
    ReservationToPanier: (state, action) => {
      const { order_id, totalNet, total, items, client, avance, reservation } =
        action.payload;

      //alert(avance)
      let listItems: PanierItem[] = [];
      items.forEach((element: any) => {
        const dataitem: PanierItem = {
          article: element.article,
          outOFStock: false,
          quantity: element.quantity,
          sold_quantity: element.quantity,
          prix_unitaire: element.prix_unitaire,
          prix_total: element.prix_unitaire * element.quantity,
          remise: element.remise,
          typeRemise: "pourcentage",
          paid_quantity: 0,
          remiseClient: 0,
          prixNet: element.prix_unitaire * element.quantity,
          free: false,
          Solde: false,
        };
        listItems.push(dataitem);
      });
      return {
        ...state,
        items: listItems,
        total: Number(total),
        order_id: order_id,
        client_id: client._id,
        totalNet: Number(totalNet),
        avance: avance,
        reservation: reservation,
      };
    },
    setOrderid: (state, action) => {
      return {
        ...state,
        order_id: action.payload,
      };
    },
    setReduction: (state, action) => {
      return {
        ...state,
        reduction: state.reduction + action.payload.amount,
        Bons: [...state.Bons, action.payload.bon],
        totalNet: state.totalNet,
        total: state.total,
      };
    },
    setRefundedOrder: (state, action) => {
      return {
        ...state,
        refundedOrder: action.payload,
      };
    },
    setInstantRemise: (state, action) => {
      return {
        ...state,
        items: state.items.map((item) =>
          item.free === false ? { ...item, remise: action.payload } : item,
        ),
        InstantRemise: action.payload,
      };
    },

    addClient: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        client_id: action.payload,
      };
    },

    setInitialTotals: (
      state,
      action: PayloadAction<{
        timbre: any;
        timbre_facture: any;
      }>,
    ) => {
      const { timbre, timbre_facture } = action.payload;

      const baseHT = state.total_ht;
      const baseTTC = state.total;
      const baseHtNet = state.total_net_ht;
      const BaseTTCNet = state.totalNet;
      const fees = (timbre || 0) + (timbre_facture || 0);

      return {
        ...state,
        timbre: timbre ?? state.timbre,
        timbre_facture: timbre_facture ?? state.timbre_facture,
        total: baseTTC + (timbre ?? 0) + (timbre_facture ?? 0),
        // Don't add fees to HT values unless they're specifically HT fees
        total_ht: baseHT,
        totalNet: BaseTTCNet + (timbre ?? 0) + (timbre_facture ?? 0),
        total_net_ht: baseHtNet,
      };
    },

    setClientRemise: (state, action) => {
      return {
        ...state,
        items: state.items.map((item) => ({
          ...item,
          remiseClient: action.payload,
        })),
        clientRemise: action.payload,
      };
    },
    setNetPrice: (state) => {
      const initialValue = Number(state.timbre) + Number(state.timbre_facture);
      const updatedItems = state.items.map((item) => ({
        ...item,

        prixNet:
          state.typeRemise === "pourcentage"
            ? item.prix_unitaire * item.quantity -
              calculateRemise(item).totalRemise
            : item.prix_unitaire * item.quantity - item.remise,
        total_ht_net:
          item.total_ht &&
          (state.typeRemise === "pourcentage"
            ? item.total_ht - calculateRemise(item).totalRemise
            : item.total_ht - item.remise),
      }));
      const updatedItemsRefunded = state.refundedItems.map((item) => ({
        ...item,

        prixNet:
          state.typeRemise === "pourcentage"
            ? item.prix_unitaire * item.quantity -
              calculateRemise(item).totalRemise
            : item.prix_unitaire * item.quantity - item.remise,
        total_ht_net:
          item.total_ht &&
          (state.typeRemise === "pourcentage"
            ? item.total_ht - calculateRemise(item).totalRemise
            : item.total_ht - item.remise),
      }));

      const cartTotalNet =
        updatedItems.reduce(
          (total, item) => total + item.prixNet,
          initialValue,
        ) +
        updatedItemsRefunded.reduce((total, item) => total + item.prixNet, 0);
      const cartTotal =
        updatedItems.reduce(
          (total, item) =>
            state.operationType === "Echange" && item.quantity < 0
              ? total + item.prixNet
              : total + item.prix_total,
          initialValue,
        ) +
        updatedItemsRefunded.reduce(
          (total, item) =>
            state.operationType === "Echange" && item.quantity < 0
              ? total + item.prixNet
              : total + item.prix_total,
          initialValue,
        );

      const cartTotalHTNet =
        updatedItems.reduce(
          (total, item) => total + (item.total_ht_net ? item.total_ht_net : 0),
          initialValue,
        ) +
        updatedItemsRefunded.reduce(
          (total, item) => total + (item.total_ht_net ? item.total_ht_net : 0),
          initialValue,
        );

      const cartTotalHT =
        updatedItems.reduce(
          (total, item) =>
            state.operationType === "Echange" &&
            item.quantity < 0 &&
            item.total_ht_net
              ? total + item.total_ht_net
              : item.total_ht
              ? total + item.total_ht
              : 0,
          initialValue,
        ) +
        updatedItemsRefunded.reduce(
          (total, item) =>
            state.operationType === "Echange" &&
            item.quantity < 0 &&
            item.total_ht_net
              ? total + item.total_ht_net
              : item.total_ht
              ? total + item.total_ht
              : 0,
          initialValue,
        );

      return {
        ...state,
        items: updatedItems,
        refundedItems: updatedItemsRefunded,

        totalNet: cartTotalNet,
        total: cartTotal,
        total_ht: cartTotalHT,
        total_net_ht: cartTotalHTNet,
      };
    },
    setNetPriceArticle: (state) => {
      const updatedItems = state.items.map((item) => ({
        ...item,
        prixNet:
          state.typeRemise === "pourcentage"
            ? item.prix_unitaire * item.quantity -
              calculateRemise(item).totalRemise
            : item.prix_unitaire * item.quantity - item.remise,
        total_ht_net:
          state.typeRemise === "pourcentage"
            ? item.article.prix_vente_ht * item.quantity -
              calculateRemise(item).totalRemise
            : item.article.prix_vente_ht * item.quantity - item.remise,
      }));

      return {
        ...state,
        items: updatedItems,
      };
    },

    setItemInstantRemise: (state, action: PayloadAction<any>) => {
      const itemToIncreaseId = action.payload.id;
      const remise = action.payload.remise;
      const itemToIncrease = state.items.find(
        (item) => item.article._id === itemToIncreaseId,
      );
      if (itemToIncrease) {
        const updatedItems = state.items.map((item) =>
          item.article._id === itemToIncreaseId
            ? {
                ...item,
                remise: remise,
              }
            : item,
        );
        return {
          ...state,
          items: updatedItems,
        };
      } else {
        return state;
      }
    },
    setItemAvailability: (state, action: PayloadAction<any>) => {
      const itemToIncreaseId = action.payload.article;
      const stock = action.payload.stock;

      const itemToIncrease = state.items.find(
        (item) => item.article._id === itemToIncreaseId,
      );
      if (itemToIncrease) {
        const updatedItems = state.items.map((item) =>
          item.article._id === itemToIncreaseId
            ? item.quantity > stock
              ? {
                  ...item,
                  outOFStock: true,
                }
              : {
                  ...item,
                  outOFStock: false,
                }
            : item,
        );

        return {
          ...state,
          items: updatedItems,
        };
      } else {
        return state;
      }
    },
    /*  const globalRemises = remises.filter(
        (remise: any) =>
          !updatedItems.some(
            (item) =>
              item.article._id === remise?.conditions_produits[0]?.article_id ||
              remise?.conditions_produits?.map((cp: any) =>
                cp?.groupe?.list_article?.includes(item?.article?._id)
              ) ||
              item.article.articleparent ===
                remise?.conditions_produits[0]?.article_id
          )
      );
      
      
         if (globalRemises && globalRemises.length !== 0) {
          updatedItems.map((item) => {
            return !Object.keys(remisesByProduct).includes(item.article._id) &&
              item.type !== "defaut"
              ? (item.remise = maxRemise(globalRemises))
              : null;
          });
        }
          */
    setRemises: (state, action: PayloadAction<any>) => {
      const remises = action.payload.data.remises;
      if (!remises || remises.length === 0) {
        state.items = state.items.map((item) => ({
          ...item,
          remise: 0,
        }));
        return;
      }

      console.log("remises raw", JSON.stringify(remises, null, 2)); // ← ADD THIS
      console.log(
        "cart items",
        JSON.stringify(
          state.items.map((i) => ({
            _id: i.article._id,
            articleparent: i.article.articleparent,
            categorie: i.article.categorie,
            souscategorie: i.article.souscategorie,
            carte: i.article.carte,
          })),
          null,
          2,
        ),
      );
      const typeRemise = action.payload.remisetype || "max";
      const cartDefaultRemise = state.InstantRemise;

      const pickRemise = (list: any[]) =>
        typeRemise !== "max" ? LastCreatedRemise(list) : maxRemise(list);

      let updatedItems = state.items.map((item) => ({
        ...item,
        remise: item?.remise || cartDefaultRemise,
      }));

      const productRemises = remises?.filter((remise: any) =>
        updatedItems.some(
          (item) =>
            item.article._id === remise?.conditions_produits[0]?.article_id ||
            item.article.articleparent ===
              remise?.conditions_produits[0]?.article_id ||
            remise?.conditions_produits?.some((cp: any) =>
              cp?.groupe?.list_article?.some(
                (id: any) =>
                  String(id) === String(item?.article?._id) ||
                  String(id) === String(item?.article?.articleparent),
              ),
            ),
        ),
      );
      const globalRemises = remises?.filter(
        (remise: any) =>
          !remise.conditions_produits ||
          remise.conditions_produits.length === 0,
      );

      if (globalRemises?.length > 0) {
        const globalRemiseValue = pickRemise(globalRemises);
        updatedItems = updatedItems.map((item) =>
          item.type !== "defaut"
            ? { ...item, remise: globalRemiseValue }
            : item,
        );
      }
      const remisesByProduct = _.groupBy(
        productRemises,
        "conditions_produits[0].article_id",
      );
      const remisesByGroupe = _.groupBy(
        productRemises,
        (r: any) => r.conditions_produits?.[0]?.groupe?._id,
      );
      const remisesBySSCategorie = _.groupBy(
        remises,
        "conditions_produits[0].sous_categorie_id",
      );
      const remisesByCatgorie = _.groupBy(
        remises,
        "conditions_produits[0].categorie_id",
      );
      const remisesByCarte = _.groupBy(
        remises,
        "conditions_produits[0].carte_id",
      );

      const cleanKeys = (obj: Record<string, any>) => {
        Object.keys(obj).forEach((key) => {
          if (!key || key === "undefined" || key === "null") delete obj[key];
        });
      };

      cleanKeys(remisesByProduct);
      cleanKeys(remisesByGroupe);
      cleanKeys(remisesBySSCategorie);
      cleanKeys(remisesByCatgorie);
      cleanKeys(remisesByCarte);

      // ── by carte ──
      Object.entries(remisesByCarte).forEach(([key, value]: any) => {
        updatedItems = updatedItems.map((item) =>
          String(item.article.carte) === String(key) && item.type !== "defaut"
            ? { ...item, remise: pickRemise(value) }
            : item,
        );
      });

      // ── by sous-categorie ──
      Object.entries(remisesBySSCategorie).forEach(([key, value]: any) => {
        updatedItems = updatedItems.map((item) =>
          String(item.article.souscategorie) === String(key) &&
          item.type !== "defaut"
            ? { ...item, remise: pickRemise(value) }
            : item,
        );
      });

      // ── by categorie ──
      Object.entries(remisesByCatgorie).forEach(([key, value]: any) => {
        updatedItems = updatedItems.map((item) =>
          String(item.article.categorie) === String(key) &&
          item.type !== "defaut"
            ? { ...item, remise: pickRemise(value) }
            : item,
        );
      });

      // ── by article / articleparent ──
      Object.entries(remisesByProduct).forEach(([key, value]: any) => {
        updatedItems = updatedItems.map((item) => {
          if (item.type === "defaut") return item;
          if (
            String(item.article._id) === String(key) ||
            String(item.article.articleparent) === String(key)
          ) {
            return { ...item, remise: pickRemise(value) };
          }
          return item;
        });
      });

      // ── by groupe ──
      Object.entries(remisesByGroupe).forEach(
        ([groupeId, groupeRemises]: any) => {
          const listArticles: any[] =
            groupeRemises[0]?.conditions_produits?.[0]?.groupe?.list_article ||
            [];
          if (!listArticles.length) return;

          const remiseValue = pickRemise(groupeRemises);

          updatedItems = updatedItems.map((item) => {
            if (item.type === "defaut") return item;
            const articleId = String(item.article._id);
            const parentId = String(item.article.articleparent);
            const inGroupe =
              listArticles.some((id: any) => String(id) === articleId) ||
              listArticles.some((id: any) => String(id) === parentId);
            if (inGroupe) {
              return { ...item, remise: remiseValue };
            }
            return item;
          });
        },
      );

      state.items = updatedItems;
    },
    setSoldes: (state, action: PayloadAction<any>) => {
      const { soldes } = action.payload;
      let items = [...state.items];

      // --- ÉTAPE 1: FUSION ET PROTECTION DES ARTICLES AVEC REMISE ---
      // On sépare les articles qui ont déjà une remise (on n'y touche pas)
      const itemsAvecRemise = items.filter(
        (i) => (i.remise > 0 && !i.Solde) || i.remiseClient > 0,
      );

      // On prend le reste pour le calcul des soldes
      let itemsEligibles = items.filter((i) => !itemsAvecRemise.includes(i));

      // Fusion des lignes soldées existantes avec leurs parents normaux
      let flatItems = itemsEligibles.reduce((acc: any[], item) => {
        const existing = acc.find(
          (i) => i.article._id === item.article._id && !i.Solde,
        );
        if (item.Solde && existing) {
          existing.quantity += item.quantity;
          return acc;
        }
        if (item.Solde && !existing) {
          acc.push({ ...item, Solde: false, remise: 0, sold_quantity: 0 });
          return acc;
        }
        acc.push({ ...item, remise: 0, sold_quantity: 0 });
        return acc;
      }, []);

      // --- ÉTAPE 2: CALCUL PAR GROUPE ---
      const soldesByGroupe = _.groupBy(
        soldes,
        (s: any) => s.conditions_produits?.[0]?.groupe?._id,
      );

      Object.entries(soldesByGroupe).forEach(([groupId, s]: any) => {
        const soldeConfig = s[0];
        const condition = soldeConfig.conditions_produits?.[0];
        if (!condition || !condition.groupe?.list_article) return;

        // On ne travaille que sur les articles du groupe qui n'ont PAS de remise
        let groupeItems = flatItems
          .filter((item) =>
            condition.groupe.list_article.includes(item.article._id),
          )
          .sort((a, b) => a.article.prix_vente_ttc - b.article.prix_vente_ttc);

        let totalQty = groupeItems.reduce((sum, i) => sum + i.quantity, 0);
        let nbLots = Math.floor(totalQty / 2);
        let qtyToDiscount = nbLots * (condition.qtesoldee || 1);

        // --- ÉTAPE 3: EXTRACTION DES LIGNES SOLDÉES ---
        for (let item of groupeItems) {
          if (qtyToDiscount <= 0) break;

          let amountFromThisItem = Math.min(item.quantity, qtyToDiscount);

          item.quantity -= amountFromThisItem;

          flatItems.unshift({
            ...item,
            quantity: amountFromThisItem,
            sold_quantity: amountFromThisItem,
            remise: soldeConfig.percentage,
            Solde: true,
            prix_total: amountFromThisItem * item.article.prix_vente_ttc,
          });

          qtyToDiscount -= amountFromThisItem;
        }
      });

      // --- ÉTAPE 4: REASSEMBLAGE ---
      // On remet ensemble les articles avec remise initiale et les nouveaux calculs
      state.items = [
        ...itemsAvecRemise,
        ...flatItems.filter((i) => i.quantity !== 0),
      ];
    },
    addFreeItem: (state, action: PayloadAction<any>) => {
      const freeItem = action.payload.article;
      const freeQte = action.payload.quantity;

      let initialCart = state.items.filter((item) => item.free === false);
      const existingItem = initialCart.find(
        (item) => item.article._id === freeItem._id,
      );
      if (existingItem) {
        if (existingItem.quantity === freeQte) {
          const updatedItems = initialCart.map((item) =>
            item.article._id === freeItem._id
              ? {
                  ...item,
                  remise: 100,
                  free: true,
                  prix_total: 0,
                }
              : item,
          );

          return {
            ...state,
            items: updatedItems,
            totalNet: state.totalNet - existingItem.prix_total, // assuming totalPrice is correct
            total: state.total - existingItem.prix_total, // assuming totalPrice is correct
          };
        }
        if (existingItem.quantity > freeQte) {
          const updatedItems = initialCart.map((item) =>
            item.article._id === freeItem._id
              ? {
                  ...item,
                  quantity: item.quantity - freeQte,
                  prix_total:
                    (item.quantity - freeQte) * item.article.prix_vente_ttc,
                }
              : item,
          );

          const newItem: PanierItem = {
            article: freeItem,
            outOFStock: false,
            quantity: freeQte,
            sold_quantity: freeQte,
            prix_unitaire: freeItem.prix_vente_ttc,
            prix_total: 0,
            paid_quantity: 0,
            remise: 100,
            typeRemise: "pourcentage",
            remiseClient: 0,
            prixNet: 0,
            free: true,
            // prix_totalHT: 0,
            // prix_unitaireHt: 0,
            // prixNetHT: 0,
          };

          return {
            ...state,
            items: [...updatedItems, newItem],

            totalNet: state.totalNet - existingItem.prix_unitaire * freeQte, // assuming totalPrice is correct
            total: state.total + existingItem.prix_unitaire * freeQte, // assuming totalPrice is correct
          };
        }
        if (existingItem.quantity < freeQte) {
          const newItem: PanierItem = {
            article: freeItem,
            outOFStock: false,
            quantity: freeQte,
            sold_quantity: freeQte,
            prix_unitaire: freeItem.prix_vente_ttc,
            prix_total: 0,
            paid_quantity: 0,
            remise: 100,
            typeRemise: "pourcentage",
            remiseClient: 0,
            prixNet: 0,
            free: true,
            // prix_totalHT: 0,
            // prix_unitaireHt: 0,
            // prixNetHT: 0,
          };

          return {
            ...state,
            items: [...initialCart, newItem],
          };
        }
      } else {
        // If the item is not in the cart, add it with quantity 1 and calculate total price
        const newItem: PanierItem = {
          article: freeItem,
          outOFStock: false,
          quantity: freeQte,
          sold_quantity: freeQte,
          prix_unitaire: freeItem.prix_vente_ttc,
          prix_total: 0,
          paid_quantity: 0,
          remise: 100,
          typeRemise: "pourcentage",
          remiseClient: 0,
          prixNet: 0,
          free: true,
          Solde: false,
          // prix_totalHT: 0,
          // prix_unitaireHt: freeItem.prix_vente_ht,
          // prixNetHT: 0,
        };

        return {
          ...state,
          items: [...initialCart, newItem],
        };
      }
    },

    setOperationType: (state, action) => {
      const newState = {
        ...state,
        operationType: action.payload.type,
      };

      return newState;
    },

    resetOperationType: (state) => {
      return {
        ...state,
        operationType: initialState.operationType,
      };
    },
    resetReduction: (state) => {
      return {
        ...state,
        reduction: initialState.reduction,
        Bons: initialState.Bons,
      };
    },
    setQuantity: (state, action) => {
      return {
        ...state,
        calculatedQuantity: action.payload,
      };
    },

    removeFromPanier: (state, action) => {
      const { article, type, remise } = action.payload;
      const itemIdToRemove = article._id;

      // Trouver l'élément à supprimer
      const itemToRemove = state.items.find(
        (item) =>
          item.article._id === itemIdToRemove &&
          item.type === type &&
          item.remise === remise,
      );

      if (itemToRemove) {
        // Filtrer les éléments pour créer une liste mise à jour
        const updatedItems = state.items.filter(
          (item) => item !== itemToRemove,
        );

        return {
          ...state,
          items: updatedItems,
          totalNet: state.totalNet - (itemToRemove.prixNet || 0),
          total: state.total - (itemToRemove.prix_total || 0),
        };
      }

      // Si l'élément à supprimer n'est pas trouvé, retourner l'état initial
      return state;
    },

    decreaseQuantity: (state, action) => {
      const itemToIncreaseId = action.payload.article._id;
      const itemToIncrease = state.items.find(
        (item) =>
          item.article._id === itemToIncreaseId &&
          item.type === action.payload.type &&
          item.remise === action.payload.remise,
      );
      if (itemToIncrease) {
        const updatedItems = state.items.map((item) =>
          item === itemToIncrease
            ? {
                ...item,
                quantity: item.quantity - 1,
                sold_quantity: item.sold_quantity - 1,
                prix_total: (item.quantity - 1) * item.article.prix_vente_ttc,
                total_ht:
                  (item.quantity - 1) * itemToIncrease.article.prix_vente_ht,
              }
            : item,
        );

        return {
          ...state,
          items: updatedItems,
          totalNet: state.totalNet - itemToIncrease.article.prix_vente_ttc,
          total: state.total - itemToIncrease.article.prix_vente_ttc,
          total_ht: state.total - itemToIncrease.article.prix_vente_ht,
        };
      } else {
        return state;
      }
    },
    increaseQuantity: (state, action) => {
      const itemToIncreaseId = action.payload.item.article._id;
      const quantity = action.payload.quantity;
      const itemToIncrease = state.items.find(
        (item) =>
          item.article._id === itemToIncreaseId &&
          item.type === action.payload.item.type &&
          item.remise === action.payload.item.remise,
      );

      if (itemToIncrease) {
        const updatedItems = state.items.map((item) =>
          item === itemToIncrease
            ? {
                ...item,
                quantity: item.quantity + quantity,
                sold_quantity: item.sold_quantity + quantity,
                prix_total:
                  (item.quantity + quantity) *
                  itemToIncrease.article.prix_vente_ttc,
                total_ht:
                  (item.quantity + 1) * itemToIncrease.article.prix_vente_ht,
              }
            : item,
        );
        const finditem = updatedItems.find(
          (item) =>
            item.article._id === itemToIncreaseId &&
            item.type === action.payload.item.type &&
            item.remise === action.payload.item.remise,
        );
        // If the item already exists, update its quantity and total price
        if (
          finditem &&
          finditem.type === "defaut" &&
          finditem?.quantity > finditem.qtemax
        ) {
          ToastWarning("la quantite depasse la quantite d'article");
          return;
        }
        return {
          ...state,
          items: updatedItems,
          totalNet: state.totalNet + itemToIncrease.article.prix_vente_ttc,
          total: state.total + itemToIncrease.article.prix_vente_ttc,
          total_ht: state.total_ht + itemToIncrease.article.prix_vente_ht,
        };
      } else {
        return state;
      }
    },
    resetPanier: (state, action) => {
      const timbre = action.payload;
      return {
        ...state,
        items: [],
        refundedItems: [],
        total: 0,
        totalNet: 0,
        total_ht: 0,
        total_net_ht: 0,
        client_id: "",
        orderConfirmed: false,
        order_id: null,
        defaultClient: state.defaultClient || {},
        refundedOrder: initialState.refundedOrder,
        refundedArticle: initialState.refundedArticle,
        reduction: 0,
        InstantRemise: 0,
        clientRemise: 0,
        programmesFidelite: [],
        gratuites: [],
        operationType: "Vente",
        avance: 0,
        selectedOrders: [],
        typeRemise: "pourcentage",
        reservation: undefined,
        timbre: timbre,
        timbre_facture: 0,
      };
    },
    confirmOrder: (state) => {
      return {
        ...state,
        orderConfirmed: true,
      };
    },
    payQuantity: (state, action: PayloadAction<string>) => {
      const itemToIncreaseId = action.payload;
      const itemToIncrease = state.items.find(
        (item) => item.article._id === itemToIncreaseId,
      );
      if (itemToIncrease) {
        const updatedItems = state.items.map((item) =>
          item.article._id === itemToIncreaseId
            ? {
                ...item,
                paid_quantity: item.paid_quantity + 1,
              }
            : item,
        );

        return {
          ...state,
          items: updatedItems,
        };
      } else {
        return state;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findDefaultClientsBySociete.fulfilled, (state, action) => {
      const defaultClientId = action.payload._id;
      return {
        ...state,
        defaultClient: action.payload,
        // client_id: defaultClientId,
      };
    });
    builder.addCase(
      findDefaultClientsBySocieteVerifUserApi.fulfilled,
      (state, action) => {
        const defaultClientId = action.payload._id;
        return {
          ...state,
          defaultClient: action.payload,
          //   client_id: defaultClientId,
        };
      },
    );
  },
});

export const {
  addToPanier,
  updatePrix,
  addToRefunded,
  addClient,
  removeFromPanier,
  decreaseQuantity,
  increaseQuantity,
  resetPanier,
  confirmOrder,
  payQuantity,
  ReservationToPanier,
  setQuantity,
  changetotal,
  setReduction,
  resetReduction,
  setOperationType,
  resetOperationType,
  setInstantRemise,
  setItemInstantRemise,
  setClientRemise,
  setNetPrice,
  setNetPriceArticle,
  setFideliteLIst,
  addFreeItem,
  setRemises,
  setSoldes,
  setRefundedOrder,
  SelectedOrders,
  selectedRefundedOrders,
  setOrderid,
  setItemAvailability,
  setRemiseType,
  setInitialTotals,
} = PanierSlice.actions;
export const Panier = (state: RootState) => state.panier;
export const PanierItems = (state: RootState) => state.panier.items;
export const DefaultClient = (state: RootState) => state.panier.defaultClient;
export const Reduction = (state: RootState) => state.panier.reduction;
export const Bons = (state: RootState) => state.panier.Bons;

export default PanierSlice.reducer;
